import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateClientMutationVariables = Types.Exact<{
  updateClientInput: Types.UpdateClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', UpdateClient: { __typename?: 'UserSuccessEntity', success: boolean } };

export type LoginAsMutationVariables = Types.Exact<{
  userId: Types.Scalars['String'];
  token: Types.Scalars['String'];
}>;


export type LoginAsMutation = { __typename?: 'Mutation', LoginAs: { __typename?: 'SessionEntity', accessToken?: string | null, headToURL?: string | null, selectedFirmAccount?: string | null, RelatedFirms?: Array<{ __typename?: 'UserFirmAccountEntity', userId?: string | null, entityId?: string | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null } | null, Users?: { __typename?: 'UserEntity', UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null }> | null, UserFirmAccount?: { __typename?: 'UserFirmAccountEntity', userId?: string | null, entityId?: string | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null } | null, Entity?: { __typename?: 'Entity', Users?: { __typename?: 'UserEntity', id: string, email?: string | null, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, firstName: string, lastName: string, birthday?: any | null, profilePhoto?: string | null, ssn?: string | null } | null } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null } | null } };

export type ReturnToAccountMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ReturnToAccountMutation = { __typename?: 'Mutation', ReturnToAccount: { __typename?: 'SessionEntity', accessToken?: string | null, headToURL?: string | null, selectedFirmAccount?: string | null, RelatedFirms?: Array<{ __typename?: 'UserFirmAccountEntity', userId?: string | null, entityId?: string | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, createAt: any } | null, Users?: { __typename?: 'UserEntity', UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null }> | null, UserFirmAccount?: { __typename?: 'UserFirmAccountEntity', userId?: string | null, entityId?: string | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, createAt: any, businessType: Types.BusinessType, BusinessInformation?: { __typename?: 'BusinessInformationEntity', id?: string | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, createAt: any, updateAt: any, type: Types.PhoneType }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string, createAt: any, updateAt: any }> | null } | null, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, firstName: string, lastName: string, birthday?: any | null, profilePhoto?: string | null, ssn?: string | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType, createAt: any, updateAt: any }> | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, type: Types.AddressType, zip: string, createAt: any, updateAt: any }> | null } | null } | null, ProgressStatuses?: Array<{ __typename?: 'ProgressStatusesEntity', id: string, firmAccountId: string, status: string, createAt: any, updateAt: any, underlyingStatus: Types.TaxYearStatus, index: number }> | null } | null, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, languageId?: string | null, UserInformation?: { __typename?: 'UserInformationEntity', id: string, firstName: string, lastName: string, birthday?: any | null, profilePhoto?: string | null, ssn?: string | null } | null } | null, Roles?: { __typename?: 'RolesEntity', id: string, description: string } | null } | null } };

export type ResendActivationMutationVariables = Types.Exact<{
  userId: Types.Scalars['String'];
}>;


export type ResendActivationMutation = { __typename?: 'Mutation', ResendActivation: { __typename?: 'UserSuccessEntity', success: boolean } };

export type AddTaxYearInterviewJobMutationVariables = Types.Exact<{
  addJobInput: Types.AddJobInput;
}>;


export type AddTaxYearInterviewJobMutation = { __typename?: 'Mutation', AddTaxYearInterviewJob: { __typename?: 'TaxYearInterviewEntity', id: string, taxYearId: string, preparedId?: string | null, reviewedId?: string | null, interviewId: string, progressStatusId?: string | null, notes?: string | null, reviewStatus?: Types.ReviewStatus | null, createAt: any, updateAt: any, completedAt?: any | null, assignedAt: any, PreparedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, UserInformation: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, firstName: string, lastName: string, createAt?: any | null, updateAt?: any | null } } | null, ReviewedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, UserInformation: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, firstName: string, lastName: string, createAt?: any | null, updateAt?: any | null } } | null, TaxYear?: { __typename?: 'TaxYearEntity', id: string, entityId: string, year: number, createAt: any, Entity?: { __typename?: 'Entity', id: string, ownerId: string, Users?: { __typename?: 'UserEntity', id: string, email?: string | null, createAt: any, languageId?: string | null, updateAt: any, UserInformation?: { __typename?: 'UserInformationEntity', id: string, userId?: string | null, birthday?: any | null, firstName: string, lastName: string, createAt?: any | null, updateAt?: any | null } | null } | null } | null } | null, Interviews?: { __typename?: 'InterviewEntity', id: string, name: string, isLive: boolean, createAt: any, updateAt: any, isTemplate: boolean, firmAccountId: string } | null } };

export type GetPresignedUrlMutationVariables = Types.Exact<{
  fileName: Types.Scalars['String'];
  fileType: Types.Scalars['String'];
}>;


export type GetPresignedUrlMutation = { __typename?: 'Mutation', generatePreSignedPutUrl: { __typename?: 'FileSuccessEntity', url?: string | null, signedUrl?: string | null } };

export type UploadFileToUserOnDbMutationVariables = Types.Exact<{
  fileRoute: Types.Scalars['String'];
  userId: Types.Scalars['String'];
  taxYearInterviewId: Types.Scalars['String'];
  size: Types.Scalars['Float'];
}>;


export type UploadFileToUserOnDbMutation = { __typename?: 'Mutation', uploadFileToUserOnDB: { __typename?: 'FileEntity', id: string, userId?: string | null, firmAccountId?: string | null, taxYearInterviewId?: string | null, s3Key?: string | null, name?: string | null, size?: number | null, folder?: string | null, pages?: number | null, documentUsed?: boolean | null, createAt: any, updateAt: any } };

export type DeleteClientFileMutationVariables = Types.Exact<{
  s3Key: Types.Scalars['String'];
}>;


export type DeleteClientFileMutation = { __typename?: 'Mutation', deleteClientFile: { __typename?: 'FileSuccessEntity', success?: boolean | null } };

export type DeleteClientRequestedFileMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type DeleteClientRequestedFileMutation = { __typename?: 'Mutation', DeleteClientRequestedFile: { __typename?: 'RequestedFilesEntity', id: string } };

export type UpdateClientFileMutationVariables = Types.Exact<{
  updateFileInput: Types.UpdateFileInput;
}>;


export type UpdateClientFileMutation = { __typename?: 'Mutation', updateFile: { __typename?: 'FileEntity', id: string, userId?: string | null, firmAccountId?: string | null, taxYearInterviewId?: string | null, s3Key?: string | null, name?: string | null, size?: number | null, folder?: string | null, pages?: number | null, documentUsed?: boolean | null, documentReviewed?: boolean | null, createAt: any, updateAt: any } };

export type UploadFileToFirmOnDbMutationVariables = Types.Exact<{
  fileRoute: Types.Scalars['String'];
  taxYearInterviewId: Types.Scalars['String'];
  size: Types.Scalars['Float'];
}>;


export type UploadFileToFirmOnDbMutation = { __typename?: 'Mutation', uploadFileToFirmOnDB: { __typename?: 'FileEntity', id: string, userId?: string | null, firmAccountId?: string | null, taxYearInterviewId?: string | null, s3Key?: string | null, name?: string | null, size?: number | null, folder?: string | null, pages?: number | null, documentUsed?: boolean | null, createAt: any, updateAt: any } };

export type DownloadFileFromS3MutationVariables = Types.Exact<{
  s3Key: Types.Scalars['String'];
  messageId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type DownloadFileFromS3Mutation = { __typename?: 'Mutation', downloadFile: { __typename?: 'FileSuccessEntity', success?: boolean | null, signedUrl?: string | null } };

export type DownloadAllFilesFromS3MutationVariables = Types.Exact<{
  s3Keys: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type DownloadAllFilesFromS3Mutation = { __typename?: 'Mutation', downloadAllFiles: { __typename?: 'FileSuccessEntity', success?: boolean | null, signedUrlArray?: Array<{ __typename?: 'FileDownloadEntity', url?: string | null, name?: string | null }> | null } };

export type MarkInterviewAsCompletedMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type MarkInterviewAsCompletedMutation = { __typename?: 'Mutation', markInterviewAsCompleted: { __typename?: 'TaxYearInterviewEntity', completedAt?: any | null } };

export type MarkInterviewAsNotCompletedMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type MarkInterviewAsNotCompletedMutation = { __typename?: 'Mutation', markInterviewAsNotCompleted: { __typename?: 'TaxYearInterviewEntity', completedAt?: any | null } };

export type AnswersFragment = { __typename?: 'AnswerEntity', id: string, description: string, taxYearInterviewId: string, questionId: string, createAt: any, updateAt: any, completedAt?: any | null, requestAt?: any | null };

export type CreateAnswerMutationVariables = Types.Exact<{
  createAnswerInput: Types.CreateAnswerInput;
}>;


export type CreateAnswerMutation = { __typename?: 'Mutation', createAnswer: { __typename?: 'AnswerEntity', id: string, description: string, taxYearInterviewId: string, questionId: string, createAt: any, updateAt: any, completedAt?: any | null, requestAt?: any | null } };

export type UpdateAnswerMutationVariables = Types.Exact<{
  updateAnswerInput: Types.UpdateAnswerInput;
}>;


export type UpdateAnswerMutation = { __typename?: 'Mutation', updateAnswer: { __typename?: 'AnswerEntity', id: string, description: string, taxYearInterviewId: string, questionId: string, createAt: any, updateAt: any, completedAt?: any | null, requestAt?: any | null } };

export type SendInterviewMutationVariables = Types.Exact<{
  taxYearInterviewId: Types.Scalars['String'];
}>;


export type SendInterviewMutation = { __typename?: 'Mutation', SendInterview: { __typename?: 'UserSuccessEntity', success: boolean } };

export type TasksFragment = { __typename?: 'TaskEntity', id: string, taxYearId?: string | null, taskType?: Types.TaskType | null, completedAt?: any | null, deletedAt?: any | null, createAt: any, updateAt: any, FileRequests?: Array<{ __typename?: 'FileRequestEntity', id: string, userId?: string | null, signedFileId?: string | null, compiledFileId?: string | null, title?: string | null, notes?: string | null, signatureRequest?: any | null, signatureComplete?: any | null, compiledHash?: string | null, clientId?: string | null, taxYearInterviewId: string, taskId?: string | null, firmAccountId?: string | null, createAt: any, updateAt: any }> | null, Payments?: Array<{ __typename?: 'PaymentsEntity', id: string, entityId?: string | null, taskId?: string | null, taxYearInterviewId?: string | null, firmAccountId?: string | null, paymentProcessorId?: string | null, totalDollarAmount?: number | null, paymentProcessorFee?: number | null, referralFee?: number | null, preparerFee?: number | null, requestAt?: any | null, completedAt?: any | null, promisedAt?: any | null, discountApplied?: number | null, paidOffline?: boolean | null, deletedAt?: any | null, createAt?: any | null, updateAt?: any | null, Invoices?: Array<{ __typename?: 'InvoicesEntity', id: string, description: string, priceEach: number, paymentId: string, quantity: number, createAt: any, updateAt: any }> | null }> | null };

export type MarkFilesReceivedMutationVariables = Types.Exact<{
  taxYearInterviewId: Types.Scalars['String'];
}>;


export type MarkFilesReceivedMutation = { __typename?: 'Mutation', markFilesReceived: Array<{ __typename?: 'TaskEntity', id: string, taxYearId?: string | null, taskType?: Types.TaskType | null, completedAt?: any | null, deletedAt?: any | null, createAt: any, updateAt: any, FileRequests?: Array<{ __typename?: 'FileRequestEntity', id: string, userId?: string | null, signedFileId?: string | null, compiledFileId?: string | null, title?: string | null, notes?: string | null, signatureRequest?: any | null, signatureComplete?: any | null, compiledHash?: string | null, clientId?: string | null, taxYearInterviewId: string, taskId?: string | null, firmAccountId?: string | null, createAt: any, updateAt: any }> | null, Payments?: Array<{ __typename?: 'PaymentsEntity', id: string, entityId?: string | null, taskId?: string | null, taxYearInterviewId?: string | null, firmAccountId?: string | null, paymentProcessorId?: string | null, totalDollarAmount?: number | null, paymentProcessorFee?: number | null, referralFee?: number | null, preparerFee?: number | null, requestAt?: any | null, completedAt?: any | null, promisedAt?: any | null, discountApplied?: number | null, paidOffline?: boolean | null, deletedAt?: any | null, createAt?: any | null, updateAt?: any | null, Invoices?: Array<{ __typename?: 'InvoicesEntity', id: string, description: string, priceEach: number, paymentId: string, quantity: number, createAt: any, updateAt: any }> | null }> | null }> };

export type MarkFilesNotReceivedMutationVariables = Types.Exact<{
  taxYearInterviewId: Types.Scalars['String'];
}>;


export type MarkFilesNotReceivedMutation = { __typename?: 'Mutation', markFilesNotReceived: Array<{ __typename?: 'TaskEntity', id: string, taxYearId?: string | null, taskType?: Types.TaskType | null, completedAt?: any | null, deletedAt?: any | null, createAt: any, updateAt: any, FileRequests?: Array<{ __typename?: 'FileRequestEntity', id: string, userId?: string | null, signedFileId?: string | null, compiledFileId?: string | null, title?: string | null, notes?: string | null, signatureRequest?: any | null, signatureComplete?: any | null, compiledHash?: string | null, clientId?: string | null, taxYearInterviewId: string, taskId?: string | null, firmAccountId?: string | null, createAt: any, updateAt: any }> | null, Payments?: Array<{ __typename?: 'PaymentsEntity', id: string, entityId?: string | null, taskId?: string | null, taxYearInterviewId?: string | null, firmAccountId?: string | null, paymentProcessorId?: string | null, totalDollarAmount?: number | null, paymentProcessorFee?: number | null, referralFee?: number | null, preparerFee?: number | null, requestAt?: any | null, completedAt?: any | null, promisedAt?: any | null, discountApplied?: number | null, paidOffline?: boolean | null, deletedAt?: any | null, createAt?: any | null, updateAt?: any | null, Invoices?: Array<{ __typename?: 'InvoicesEntity', id: string, description: string, priceEach: number, paymentId: string, quantity: number, createAt: any, updateAt: any }> | null }> | null }> };

export type MarkPaymentsCompletedMutationVariables = Types.Exact<{
  taxYearInterviewId: Types.Scalars['String'];
}>;


export type MarkPaymentsCompletedMutation = { __typename?: 'Mutation', markPaymentsCompleted: Array<{ __typename?: 'TaskEntity', id: string, taxYearId?: string | null, taskType?: Types.TaskType | null, completedAt?: any | null, deletedAt?: any | null, createAt: any, updateAt: any, FileRequests?: Array<{ __typename?: 'FileRequestEntity', id: string, userId?: string | null, signedFileId?: string | null, compiledFileId?: string | null, title?: string | null, notes?: string | null, signatureRequest?: any | null, signatureComplete?: any | null, compiledHash?: string | null, clientId?: string | null, taxYearInterviewId: string, taskId?: string | null, firmAccountId?: string | null, createAt: any, updateAt: any }> | null, Payments?: Array<{ __typename?: 'PaymentsEntity', id: string, entityId?: string | null, taskId?: string | null, taxYearInterviewId?: string | null, firmAccountId?: string | null, paymentProcessorId?: string | null, totalDollarAmount?: number | null, paymentProcessorFee?: number | null, referralFee?: number | null, preparerFee?: number | null, requestAt?: any | null, completedAt?: any | null, promisedAt?: any | null, discountApplied?: number | null, paidOffline?: boolean | null, deletedAt?: any | null, createAt?: any | null, updateAt?: any | null, Invoices?: Array<{ __typename?: 'InvoicesEntity', id: string, description: string, priceEach: number, paymentId: string, quantity: number, createAt: any, updateAt: any }> | null }> | null }> };

export type MarkPaymentsNotCompletedMutationVariables = Types.Exact<{
  taxYearInterviewId: Types.Scalars['String'];
}>;


export type MarkPaymentsNotCompletedMutation = { __typename?: 'Mutation', markPaymentsNotCompleted: Array<{ __typename?: 'TaskEntity', id: string, taxYearId?: string | null, taskType?: Types.TaskType | null, completedAt?: any | null, deletedAt?: any | null, createAt: any, updateAt: any, FileRequests?: Array<{ __typename?: 'FileRequestEntity', id: string, userId?: string | null, signedFileId?: string | null, compiledFileId?: string | null, title?: string | null, notes?: string | null, signatureRequest?: any | null, signatureComplete?: any | null, compiledHash?: string | null, clientId?: string | null, taxYearInterviewId: string, taskId?: string | null, firmAccountId?: string | null, createAt: any, updateAt: any }> | null, Payments?: Array<{ __typename?: 'PaymentsEntity', id: string, entityId?: string | null, taskId?: string | null, taxYearInterviewId?: string | null, firmAccountId?: string | null, paymentProcessorId?: string | null, totalDollarAmount?: number | null, paymentProcessorFee?: number | null, referralFee?: number | null, preparerFee?: number | null, requestAt?: any | null, completedAt?: any | null, promisedAt?: any | null, discountApplied?: number | null, paidOffline?: boolean | null, deletedAt?: any | null, createAt?: any | null, updateAt?: any | null, Invoices?: Array<{ __typename?: 'InvoicesEntity', id: string, description: string, priceEach: number, paymentId: string, quantity: number, createAt: any, updateAt: any }> | null }> | null }> };

export type ExportToPdfMutationVariables = Types.Exact<{
  paymentId: Types.Scalars['String'];
}>;


export type ExportToPdfMutation = { __typename?: 'Mutation', exportToPDF: { __typename?: 'ExportSuccessEntity', success?: boolean | null, stringData?: string | null } };

export type GetEncryptMyTokenMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type GetEncryptMyTokenMutation = { __typename?: 'Mutation', EncryptMyToken: { __typename?: 'SessionEntity', accessToken?: string | null, selectedFirmAccount?: string | null, headToURL?: string | null } };

export type UpdateUserInformationNotesMutationVariables = Types.Exact<{
  userInformationId: Types.Scalars['String'];
  notes?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UpdateUserInformationNotesMutation = { __typename?: 'Mutation', UpdateUserInformation: { __typename?: 'UserInformationEntity', id: string, notes?: string | null } };

export type RemoveClient2FaMutationVariables = Types.Exact<{
  userId: Types.Scalars['String'];
}>;


export type RemoveClient2FaMutation = { __typename?: 'Mutation', RemoveClient2FA: { __typename?: 'UserEntity', id: string, has2Fa?: boolean | null } };

export const AnswersFragmentDoc = gql`
    fragment Answers on AnswerEntity {
  id
  description
  taxYearInterviewId
  questionId
  createAt
  updateAt
  completedAt
  requestAt
}
    `;
export const TasksFragmentDoc = gql`
    fragment Tasks on TaskEntity {
  id
  taxYearId
  taskType
  completedAt
  deletedAt
  createAt
  updateAt
  FileRequests {
    id
    userId
    signedFileId
    compiledFileId
    title
    notes
    signatureRequest
    signatureComplete
    compiledHash
    clientId
    taxYearInterviewId
    taskId
    firmAccountId
    createAt
    updateAt
  }
  Payments {
    id
    entityId
    taskId
    taxYearInterviewId
    firmAccountId
    paymentProcessorId
    totalDollarAmount
    paymentProcessorFee
    referralFee
    preparerFee
    requestAt
    completedAt
    promisedAt
    discountApplied
    paidOffline
    deletedAt
    createAt
    updateAt
    Invoices {
      id
      description
      priceEach
      paymentId
      quantity
      createAt
      updateAt
    }
  }
}
    `;
export const UpdateClientDocument = gql`
    mutation UpdateClient($updateClientInput: UpdateClientInput!) {
  UpdateClient(updateClientInput: $updateClientInput) {
    success
  }
}
    `;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      updateClientInput: // value for 'updateClientInput'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const LoginAsDocument = gql`
    mutation LoginAs($userId: String!, $token: String!) {
  LoginAs(userId: $userId, token: $token) {
    accessToken
    headToURL
    selectedFirmAccount
    RelatedFirms {
      userId
      entityId
      FirmAccount {
        id
        name
      }
      Users {
        UserInformation {
          firstName
          lastName
        }
      }
      Roles {
        id
        description
      }
    }
    UserFirmAccount {
      userId
      entityId
      FirmAccount {
        id
        name
      }
      Entity {
        Users {
          id
          email
          languageId
          UserInformation {
            id
            firstName
            lastName
            birthday
            profilePhoto
            ssn
          }
        }
      }
      Roles {
        id
        description
      }
    }
  }
}
    `;
export type LoginAsMutationFn = Apollo.MutationFunction<LoginAsMutation, LoginAsMutationVariables>;

/**
 * __useLoginAsMutation__
 *
 * To run a mutation, you first call `useLoginAsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAsMutation, { data, loading, error }] = useLoginAsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginAsMutation(baseOptions?: Apollo.MutationHookOptions<LoginAsMutation, LoginAsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAsMutation, LoginAsMutationVariables>(LoginAsDocument, options);
      }
export type LoginAsMutationHookResult = ReturnType<typeof useLoginAsMutation>;
export type LoginAsMutationResult = Apollo.MutationResult<LoginAsMutation>;
export type LoginAsMutationOptions = Apollo.BaseMutationOptions<LoginAsMutation, LoginAsMutationVariables>;
export const ReturnToAccountDocument = gql`
    mutation ReturnToAccount {
  ReturnToAccount {
    accessToken
    headToURL
    selectedFirmAccount
    RelatedFirms {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
      }
      Users {
        UserInformation {
          firstName
          lastName
        }
      }
      Roles {
        id
        description
      }
    }
    UserFirmAccount {
      userId
      entityId
      FirmAccount {
        id
        name
        createAt
        businessType
        BusinessInformation {
          id
          Phones {
            id
            value
            createAt
            updateAt
            type
          }
          Address {
            id
            lineOne
            lineTwo
            city
            state
            type
            zip
            createAt
            updateAt
          }
        }
        Users {
          id
          email
          languageId
          UserInformation {
            id
            firstName
            lastName
            birthday
            profilePhoto
            ssn
            Phones {
              id
              value
              type
              createAt
              updateAt
            }
            Address {
              id
              lineOne
              lineTwo
              city
              state
              type
              zip
              createAt
              updateAt
            }
          }
        }
        ProgressStatuses {
          id
          firmAccountId
          status
          createAt
          updateAt
          underlyingStatus
          index
        }
      }
      Users {
        id
        email
        languageId
        UserInformation {
          id
          firstName
          lastName
          birthday
          profilePhoto
          ssn
        }
      }
      Roles {
        id
        description
      }
    }
  }
}
    `;
export type ReturnToAccountMutationFn = Apollo.MutationFunction<ReturnToAccountMutation, ReturnToAccountMutationVariables>;

/**
 * __useReturnToAccountMutation__
 *
 * To run a mutation, you first call `useReturnToAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnToAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnToAccountMutation, { data, loading, error }] = useReturnToAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useReturnToAccountMutation(baseOptions?: Apollo.MutationHookOptions<ReturnToAccountMutation, ReturnToAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReturnToAccountMutation, ReturnToAccountMutationVariables>(ReturnToAccountDocument, options);
      }
export type ReturnToAccountMutationHookResult = ReturnType<typeof useReturnToAccountMutation>;
export type ReturnToAccountMutationResult = Apollo.MutationResult<ReturnToAccountMutation>;
export type ReturnToAccountMutationOptions = Apollo.BaseMutationOptions<ReturnToAccountMutation, ReturnToAccountMutationVariables>;
export const ResendActivationDocument = gql`
    mutation ResendActivation($userId: String!) {
  ResendActivation(userId: $userId) {
    success
  }
}
    `;
export type ResendActivationMutationFn = Apollo.MutationFunction<ResendActivationMutation, ResendActivationMutationVariables>;

/**
 * __useResendActivationMutation__
 *
 * To run a mutation, you first call `useResendActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendActivationMutation, { data, loading, error }] = useResendActivationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResendActivationMutation(baseOptions?: Apollo.MutationHookOptions<ResendActivationMutation, ResendActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendActivationMutation, ResendActivationMutationVariables>(ResendActivationDocument, options);
      }
export type ResendActivationMutationHookResult = ReturnType<typeof useResendActivationMutation>;
export type ResendActivationMutationResult = Apollo.MutationResult<ResendActivationMutation>;
export type ResendActivationMutationOptions = Apollo.BaseMutationOptions<ResendActivationMutation, ResendActivationMutationVariables>;
export const AddTaxYearInterviewJobDocument = gql`
    mutation AddTaxYearInterviewJob($addJobInput: AddJobInput!) {
  AddTaxYearInterviewJob(addJobInput: $addJobInput) {
    id
    taxYearId
    preparedId
    reviewedId
    interviewId
    progressStatusId
    notes
    reviewStatus
    createAt
    updateAt
    completedAt
    assignedAt
    PreparedUser {
      id
      email
      UserInformation {
        id
        userId
        userId
        birthday
        firstName
        lastName
        createAt
        updateAt
      }
    }
    ReviewedUser {
      id
      email
      UserInformation {
        id
        userId
        userId
        birthday
        firstName
        lastName
        createAt
        updateAt
      }
    }
    TaxYear {
      id
      entityId
      year
      createAt
      Entity {
        id
        ownerId
        Users {
          id
          email
          createAt
          languageId
          updateAt
          UserInformation {
            id
            userId
            birthday
            firstName
            lastName
            createAt
            updateAt
          }
        }
      }
    }
    Interviews {
      id
      name
      isLive
      createAt
      updateAt
      isTemplate
      firmAccountId
    }
  }
}
    `;
export type AddTaxYearInterviewJobMutationFn = Apollo.MutationFunction<AddTaxYearInterviewJobMutation, AddTaxYearInterviewJobMutationVariables>;

/**
 * __useAddTaxYearInterviewJobMutation__
 *
 * To run a mutation, you first call `useAddTaxYearInterviewJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaxYearInterviewJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaxYearInterviewJobMutation, { data, loading, error }] = useAddTaxYearInterviewJobMutation({
 *   variables: {
 *      addJobInput: // value for 'addJobInput'
 *   },
 * });
 */
export function useAddTaxYearInterviewJobMutation(baseOptions?: Apollo.MutationHookOptions<AddTaxYearInterviewJobMutation, AddTaxYearInterviewJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaxYearInterviewJobMutation, AddTaxYearInterviewJobMutationVariables>(AddTaxYearInterviewJobDocument, options);
      }
export type AddTaxYearInterviewJobMutationHookResult = ReturnType<typeof useAddTaxYearInterviewJobMutation>;
export type AddTaxYearInterviewJobMutationResult = Apollo.MutationResult<AddTaxYearInterviewJobMutation>;
export type AddTaxYearInterviewJobMutationOptions = Apollo.BaseMutationOptions<AddTaxYearInterviewJobMutation, AddTaxYearInterviewJobMutationVariables>;
export const GetPresignedUrlDocument = gql`
    mutation GetPresignedURL($fileName: String!, $fileType: String!) {
  generatePreSignedPutUrl(fileName: $fileName, fileType: $fileType) {
    url
    signedUrl
  }
}
    `;
export type GetPresignedUrlMutationFn = Apollo.MutationFunction<GetPresignedUrlMutation, GetPresignedUrlMutationVariables>;

/**
 * __useGetPresignedUrlMutation__
 *
 * To run a mutation, you first call `useGetPresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPresignedUrlMutation, { data, loading, error }] = useGetPresignedUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      fileType: // value for 'fileType'
 *   },
 * });
 */
export function useGetPresignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetPresignedUrlMutation, GetPresignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPresignedUrlMutation, GetPresignedUrlMutationVariables>(GetPresignedUrlDocument, options);
      }
export type GetPresignedUrlMutationHookResult = ReturnType<typeof useGetPresignedUrlMutation>;
export type GetPresignedUrlMutationResult = Apollo.MutationResult<GetPresignedUrlMutation>;
export type GetPresignedUrlMutationOptions = Apollo.BaseMutationOptions<GetPresignedUrlMutation, GetPresignedUrlMutationVariables>;
export const UploadFileToUserOnDbDocument = gql`
    mutation UploadFileToUserOnDB($fileRoute: String!, $userId: String!, $taxYearInterviewId: String!, $size: Float!) {
  uploadFileToUserOnDB(
    fileRoute: $fileRoute
    userId: $userId
    taxYearInterviewId: $taxYearInterviewId
    size: $size
  ) {
    id
    userId
    firmAccountId
    taxYearInterviewId
    s3Key
    name
    size
    folder
    pages
    documentUsed
    createAt
    updateAt
  }
}
    `;
export type UploadFileToUserOnDbMutationFn = Apollo.MutationFunction<UploadFileToUserOnDbMutation, UploadFileToUserOnDbMutationVariables>;

/**
 * __useUploadFileToUserOnDbMutation__
 *
 * To run a mutation, you first call `useUploadFileToUserOnDbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileToUserOnDbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileToUserOnDbMutation, { data, loading, error }] = useUploadFileToUserOnDbMutation({
 *   variables: {
 *      fileRoute: // value for 'fileRoute'
 *      userId: // value for 'userId'
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useUploadFileToUserOnDbMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileToUserOnDbMutation, UploadFileToUserOnDbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileToUserOnDbMutation, UploadFileToUserOnDbMutationVariables>(UploadFileToUserOnDbDocument, options);
      }
export type UploadFileToUserOnDbMutationHookResult = ReturnType<typeof useUploadFileToUserOnDbMutation>;
export type UploadFileToUserOnDbMutationResult = Apollo.MutationResult<UploadFileToUserOnDbMutation>;
export type UploadFileToUserOnDbMutationOptions = Apollo.BaseMutationOptions<UploadFileToUserOnDbMutation, UploadFileToUserOnDbMutationVariables>;
export const DeleteClientFileDocument = gql`
    mutation DeleteClientFile($s3Key: String!) {
  deleteClientFile(s3Key: $s3Key) {
    success
  }
}
    `;
export type DeleteClientFileMutationFn = Apollo.MutationFunction<DeleteClientFileMutation, DeleteClientFileMutationVariables>;

/**
 * __useDeleteClientFileMutation__
 *
 * To run a mutation, you first call `useDeleteClientFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientFileMutation, { data, loading, error }] = useDeleteClientFileMutation({
 *   variables: {
 *      s3Key: // value for 's3Key'
 *   },
 * });
 */
export function useDeleteClientFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientFileMutation, DeleteClientFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientFileMutation, DeleteClientFileMutationVariables>(DeleteClientFileDocument, options);
      }
export type DeleteClientFileMutationHookResult = ReturnType<typeof useDeleteClientFileMutation>;
export type DeleteClientFileMutationResult = Apollo.MutationResult<DeleteClientFileMutation>;
export type DeleteClientFileMutationOptions = Apollo.BaseMutationOptions<DeleteClientFileMutation, DeleteClientFileMutationVariables>;
export const DeleteClientRequestedFileDocument = gql`
    mutation DeleteClientRequestedFile($id: String!) {
  DeleteClientRequestedFile(id: $id) {
    id
  }
}
    `;
export type DeleteClientRequestedFileMutationFn = Apollo.MutationFunction<DeleteClientRequestedFileMutation, DeleteClientRequestedFileMutationVariables>;

/**
 * __useDeleteClientRequestedFileMutation__
 *
 * To run a mutation, you first call `useDeleteClientRequestedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientRequestedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientRequestedFileMutation, { data, loading, error }] = useDeleteClientRequestedFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientRequestedFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientRequestedFileMutation, DeleteClientRequestedFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientRequestedFileMutation, DeleteClientRequestedFileMutationVariables>(DeleteClientRequestedFileDocument, options);
      }
export type DeleteClientRequestedFileMutationHookResult = ReturnType<typeof useDeleteClientRequestedFileMutation>;
export type DeleteClientRequestedFileMutationResult = Apollo.MutationResult<DeleteClientRequestedFileMutation>;
export type DeleteClientRequestedFileMutationOptions = Apollo.BaseMutationOptions<DeleteClientRequestedFileMutation, DeleteClientRequestedFileMutationVariables>;
export const UpdateClientFileDocument = gql`
    mutation UpdateClientFile($updateFileInput: UpdateFileInput!) {
  updateFile(updateFileInput: $updateFileInput) {
    id
    userId
    firmAccountId
    taxYearInterviewId
    s3Key
    name
    size
    folder
    pages
    documentUsed
    documentReviewed
    createAt
    updateAt
  }
}
    `;
export type UpdateClientFileMutationFn = Apollo.MutationFunction<UpdateClientFileMutation, UpdateClientFileMutationVariables>;

/**
 * __useUpdateClientFileMutation__
 *
 * To run a mutation, you first call `useUpdateClientFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientFileMutation, { data, loading, error }] = useUpdateClientFileMutation({
 *   variables: {
 *      updateFileInput: // value for 'updateFileInput'
 *   },
 * });
 */
export function useUpdateClientFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientFileMutation, UpdateClientFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientFileMutation, UpdateClientFileMutationVariables>(UpdateClientFileDocument, options);
      }
export type UpdateClientFileMutationHookResult = ReturnType<typeof useUpdateClientFileMutation>;
export type UpdateClientFileMutationResult = Apollo.MutationResult<UpdateClientFileMutation>;
export type UpdateClientFileMutationOptions = Apollo.BaseMutationOptions<UpdateClientFileMutation, UpdateClientFileMutationVariables>;
export const UploadFileToFirmOnDbDocument = gql`
    mutation UploadFileToFirmOnDB($fileRoute: String!, $taxYearInterviewId: String!, $size: Float!) {
  uploadFileToFirmOnDB(
    fileRoute: $fileRoute
    taxYearInterviewId: $taxYearInterviewId
    size: $size
  ) {
    id
    userId
    firmAccountId
    taxYearInterviewId
    s3Key
    name
    size
    folder
    pages
    documentUsed
    createAt
    updateAt
  }
}
    `;
export type UploadFileToFirmOnDbMutationFn = Apollo.MutationFunction<UploadFileToFirmOnDbMutation, UploadFileToFirmOnDbMutationVariables>;

/**
 * __useUploadFileToFirmOnDbMutation__
 *
 * To run a mutation, you first call `useUploadFileToFirmOnDbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileToFirmOnDbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileToFirmOnDbMutation, { data, loading, error }] = useUploadFileToFirmOnDbMutation({
 *   variables: {
 *      fileRoute: // value for 'fileRoute'
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useUploadFileToFirmOnDbMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileToFirmOnDbMutation, UploadFileToFirmOnDbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileToFirmOnDbMutation, UploadFileToFirmOnDbMutationVariables>(UploadFileToFirmOnDbDocument, options);
      }
export type UploadFileToFirmOnDbMutationHookResult = ReturnType<typeof useUploadFileToFirmOnDbMutation>;
export type UploadFileToFirmOnDbMutationResult = Apollo.MutationResult<UploadFileToFirmOnDbMutation>;
export type UploadFileToFirmOnDbMutationOptions = Apollo.BaseMutationOptions<UploadFileToFirmOnDbMutation, UploadFileToFirmOnDbMutationVariables>;
export const DownloadFileFromS3Document = gql`
    mutation DownloadFileFromS3($s3Key: String!, $messageId: String) {
  downloadFile(s3Key: $s3Key, messageId: $messageId) {
    success
    signedUrl
  }
}
    `;
export type DownloadFileFromS3MutationFn = Apollo.MutationFunction<DownloadFileFromS3Mutation, DownloadFileFromS3MutationVariables>;

/**
 * __useDownloadFileFromS3Mutation__
 *
 * To run a mutation, you first call `useDownloadFileFromS3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadFileFromS3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadFileFromS3Mutation, { data, loading, error }] = useDownloadFileFromS3Mutation({
 *   variables: {
 *      s3Key: // value for 's3Key'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDownloadFileFromS3Mutation(baseOptions?: Apollo.MutationHookOptions<DownloadFileFromS3Mutation, DownloadFileFromS3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadFileFromS3Mutation, DownloadFileFromS3MutationVariables>(DownloadFileFromS3Document, options);
      }
export type DownloadFileFromS3MutationHookResult = ReturnType<typeof useDownloadFileFromS3Mutation>;
export type DownloadFileFromS3MutationResult = Apollo.MutationResult<DownloadFileFromS3Mutation>;
export type DownloadFileFromS3MutationOptions = Apollo.BaseMutationOptions<DownloadFileFromS3Mutation, DownloadFileFromS3MutationVariables>;
export const DownloadAllFilesFromS3Document = gql`
    mutation DownloadAllFilesFromS3($s3Keys: [String!]!) {
  downloadAllFiles(s3Keys: $s3Keys) {
    success
    signedUrlArray {
      url
      name
    }
  }
}
    `;
export type DownloadAllFilesFromS3MutationFn = Apollo.MutationFunction<DownloadAllFilesFromS3Mutation, DownloadAllFilesFromS3MutationVariables>;

/**
 * __useDownloadAllFilesFromS3Mutation__
 *
 * To run a mutation, you first call `useDownloadAllFilesFromS3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAllFilesFromS3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAllFilesFromS3Mutation, { data, loading, error }] = useDownloadAllFilesFromS3Mutation({
 *   variables: {
 *      s3Keys: // value for 's3Keys'
 *   },
 * });
 */
export function useDownloadAllFilesFromS3Mutation(baseOptions?: Apollo.MutationHookOptions<DownloadAllFilesFromS3Mutation, DownloadAllFilesFromS3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAllFilesFromS3Mutation, DownloadAllFilesFromS3MutationVariables>(DownloadAllFilesFromS3Document, options);
      }
export type DownloadAllFilesFromS3MutationHookResult = ReturnType<typeof useDownloadAllFilesFromS3Mutation>;
export type DownloadAllFilesFromS3MutationResult = Apollo.MutationResult<DownloadAllFilesFromS3Mutation>;
export type DownloadAllFilesFromS3MutationOptions = Apollo.BaseMutationOptions<DownloadAllFilesFromS3Mutation, DownloadAllFilesFromS3MutationVariables>;
export const MarkInterviewAsCompletedDocument = gql`
    mutation MarkInterviewAsCompleted($id: String!) {
  markInterviewAsCompleted(id: $id) {
    completedAt
  }
}
    `;
export type MarkInterviewAsCompletedMutationFn = Apollo.MutationFunction<MarkInterviewAsCompletedMutation, MarkInterviewAsCompletedMutationVariables>;

/**
 * __useMarkInterviewAsCompletedMutation__
 *
 * To run a mutation, you first call `useMarkInterviewAsCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInterviewAsCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInterviewAsCompletedMutation, { data, loading, error }] = useMarkInterviewAsCompletedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkInterviewAsCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkInterviewAsCompletedMutation, MarkInterviewAsCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInterviewAsCompletedMutation, MarkInterviewAsCompletedMutationVariables>(MarkInterviewAsCompletedDocument, options);
      }
export type MarkInterviewAsCompletedMutationHookResult = ReturnType<typeof useMarkInterviewAsCompletedMutation>;
export type MarkInterviewAsCompletedMutationResult = Apollo.MutationResult<MarkInterviewAsCompletedMutation>;
export type MarkInterviewAsCompletedMutationOptions = Apollo.BaseMutationOptions<MarkInterviewAsCompletedMutation, MarkInterviewAsCompletedMutationVariables>;
export const MarkInterviewAsNotCompletedDocument = gql`
    mutation MarkInterviewAsNotCompleted($id: String!) {
  markInterviewAsNotCompleted(id: $id) {
    completedAt
  }
}
    `;
export type MarkInterviewAsNotCompletedMutationFn = Apollo.MutationFunction<MarkInterviewAsNotCompletedMutation, MarkInterviewAsNotCompletedMutationVariables>;

/**
 * __useMarkInterviewAsNotCompletedMutation__
 *
 * To run a mutation, you first call `useMarkInterviewAsNotCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInterviewAsNotCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInterviewAsNotCompletedMutation, { data, loading, error }] = useMarkInterviewAsNotCompletedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkInterviewAsNotCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkInterviewAsNotCompletedMutation, MarkInterviewAsNotCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInterviewAsNotCompletedMutation, MarkInterviewAsNotCompletedMutationVariables>(MarkInterviewAsNotCompletedDocument, options);
      }
export type MarkInterviewAsNotCompletedMutationHookResult = ReturnType<typeof useMarkInterviewAsNotCompletedMutation>;
export type MarkInterviewAsNotCompletedMutationResult = Apollo.MutationResult<MarkInterviewAsNotCompletedMutation>;
export type MarkInterviewAsNotCompletedMutationOptions = Apollo.BaseMutationOptions<MarkInterviewAsNotCompletedMutation, MarkInterviewAsNotCompletedMutationVariables>;
export const CreateAnswerDocument = gql`
    mutation CreateAnswer($createAnswerInput: CreateAnswerInput!) {
  createAnswer(createAnswerInput: $createAnswerInput) {
    ...Answers
  }
}
    ${AnswersFragmentDoc}`;
export type CreateAnswerMutationFn = Apollo.MutationFunction<CreateAnswerMutation, CreateAnswerMutationVariables>;

/**
 * __useCreateAnswerMutation__
 *
 * To run a mutation, you first call `useCreateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnswerMutation, { data, loading, error }] = useCreateAnswerMutation({
 *   variables: {
 *      createAnswerInput: // value for 'createAnswerInput'
 *   },
 * });
 */
export function useCreateAnswerMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnswerMutation, CreateAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnswerMutation, CreateAnswerMutationVariables>(CreateAnswerDocument, options);
      }
export type CreateAnswerMutationHookResult = ReturnType<typeof useCreateAnswerMutation>;
export type CreateAnswerMutationResult = Apollo.MutationResult<CreateAnswerMutation>;
export type CreateAnswerMutationOptions = Apollo.BaseMutationOptions<CreateAnswerMutation, CreateAnswerMutationVariables>;
export const UpdateAnswerDocument = gql`
    mutation UpdateAnswer($updateAnswerInput: UpdateAnswerInput!) {
  updateAnswer(updateAnswerInput: $updateAnswerInput) {
    ...Answers
  }
}
    ${AnswersFragmentDoc}`;
export type UpdateAnswerMutationFn = Apollo.MutationFunction<UpdateAnswerMutation, UpdateAnswerMutationVariables>;

/**
 * __useUpdateAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerMutation, { data, loading, error }] = useUpdateAnswerMutation({
 *   variables: {
 *      updateAnswerInput: // value for 'updateAnswerInput'
 *   },
 * });
 */
export function useUpdateAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnswerMutation, UpdateAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnswerMutation, UpdateAnswerMutationVariables>(UpdateAnswerDocument, options);
      }
export type UpdateAnswerMutationHookResult = ReturnType<typeof useUpdateAnswerMutation>;
export type UpdateAnswerMutationResult = Apollo.MutationResult<UpdateAnswerMutation>;
export type UpdateAnswerMutationOptions = Apollo.BaseMutationOptions<UpdateAnswerMutation, UpdateAnswerMutationVariables>;
export const SendInterviewDocument = gql`
    mutation SendInterview($taxYearInterviewId: String!) {
  SendInterview(taxYearInterviewId: $taxYearInterviewId) {
    success
  }
}
    `;
export type SendInterviewMutationFn = Apollo.MutationFunction<SendInterviewMutation, SendInterviewMutationVariables>;

/**
 * __useSendInterviewMutation__
 *
 * To run a mutation, you first call `useSendInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInterviewMutation, { data, loading, error }] = useSendInterviewMutation({
 *   variables: {
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *   },
 * });
 */
export function useSendInterviewMutation(baseOptions?: Apollo.MutationHookOptions<SendInterviewMutation, SendInterviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInterviewMutation, SendInterviewMutationVariables>(SendInterviewDocument, options);
      }
export type SendInterviewMutationHookResult = ReturnType<typeof useSendInterviewMutation>;
export type SendInterviewMutationResult = Apollo.MutationResult<SendInterviewMutation>;
export type SendInterviewMutationOptions = Apollo.BaseMutationOptions<SendInterviewMutation, SendInterviewMutationVariables>;
export const MarkFilesReceivedDocument = gql`
    mutation MarkFilesReceived($taxYearInterviewId: String!) {
  markFilesReceived(taxYearInterviewId: $taxYearInterviewId) {
    ...Tasks
  }
}
    ${TasksFragmentDoc}`;
export type MarkFilesReceivedMutationFn = Apollo.MutationFunction<MarkFilesReceivedMutation, MarkFilesReceivedMutationVariables>;

/**
 * __useMarkFilesReceivedMutation__
 *
 * To run a mutation, you first call `useMarkFilesReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFilesReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFilesReceivedMutation, { data, loading, error }] = useMarkFilesReceivedMutation({
 *   variables: {
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *   },
 * });
 */
export function useMarkFilesReceivedMutation(baseOptions?: Apollo.MutationHookOptions<MarkFilesReceivedMutation, MarkFilesReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFilesReceivedMutation, MarkFilesReceivedMutationVariables>(MarkFilesReceivedDocument, options);
      }
export type MarkFilesReceivedMutationHookResult = ReturnType<typeof useMarkFilesReceivedMutation>;
export type MarkFilesReceivedMutationResult = Apollo.MutationResult<MarkFilesReceivedMutation>;
export type MarkFilesReceivedMutationOptions = Apollo.BaseMutationOptions<MarkFilesReceivedMutation, MarkFilesReceivedMutationVariables>;
export const MarkFilesNotReceivedDocument = gql`
    mutation MarkFilesNotReceived($taxYearInterviewId: String!) {
  markFilesNotReceived(taxYearInterviewId: $taxYearInterviewId) {
    ...Tasks
  }
}
    ${TasksFragmentDoc}`;
export type MarkFilesNotReceivedMutationFn = Apollo.MutationFunction<MarkFilesNotReceivedMutation, MarkFilesNotReceivedMutationVariables>;

/**
 * __useMarkFilesNotReceivedMutation__
 *
 * To run a mutation, you first call `useMarkFilesNotReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFilesNotReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFilesNotReceivedMutation, { data, loading, error }] = useMarkFilesNotReceivedMutation({
 *   variables: {
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *   },
 * });
 */
export function useMarkFilesNotReceivedMutation(baseOptions?: Apollo.MutationHookOptions<MarkFilesNotReceivedMutation, MarkFilesNotReceivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFilesNotReceivedMutation, MarkFilesNotReceivedMutationVariables>(MarkFilesNotReceivedDocument, options);
      }
export type MarkFilesNotReceivedMutationHookResult = ReturnType<typeof useMarkFilesNotReceivedMutation>;
export type MarkFilesNotReceivedMutationResult = Apollo.MutationResult<MarkFilesNotReceivedMutation>;
export type MarkFilesNotReceivedMutationOptions = Apollo.BaseMutationOptions<MarkFilesNotReceivedMutation, MarkFilesNotReceivedMutationVariables>;
export const MarkPaymentsCompletedDocument = gql`
    mutation MarkPaymentsCompleted($taxYearInterviewId: String!) {
  markPaymentsCompleted(taxYearInterviewId: $taxYearInterviewId) {
    ...Tasks
  }
}
    ${TasksFragmentDoc}`;
export type MarkPaymentsCompletedMutationFn = Apollo.MutationFunction<MarkPaymentsCompletedMutation, MarkPaymentsCompletedMutationVariables>;

/**
 * __useMarkPaymentsCompletedMutation__
 *
 * To run a mutation, you first call `useMarkPaymentsCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPaymentsCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPaymentsCompletedMutation, { data, loading, error }] = useMarkPaymentsCompletedMutation({
 *   variables: {
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *   },
 * });
 */
export function useMarkPaymentsCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkPaymentsCompletedMutation, MarkPaymentsCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPaymentsCompletedMutation, MarkPaymentsCompletedMutationVariables>(MarkPaymentsCompletedDocument, options);
      }
export type MarkPaymentsCompletedMutationHookResult = ReturnType<typeof useMarkPaymentsCompletedMutation>;
export type MarkPaymentsCompletedMutationResult = Apollo.MutationResult<MarkPaymentsCompletedMutation>;
export type MarkPaymentsCompletedMutationOptions = Apollo.BaseMutationOptions<MarkPaymentsCompletedMutation, MarkPaymentsCompletedMutationVariables>;
export const MarkPaymentsNotCompletedDocument = gql`
    mutation MarkPaymentsNotCompleted($taxYearInterviewId: String!) {
  markPaymentsNotCompleted(taxYearInterviewId: $taxYearInterviewId) {
    ...Tasks
  }
}
    ${TasksFragmentDoc}`;
export type MarkPaymentsNotCompletedMutationFn = Apollo.MutationFunction<MarkPaymentsNotCompletedMutation, MarkPaymentsNotCompletedMutationVariables>;

/**
 * __useMarkPaymentsNotCompletedMutation__
 *
 * To run a mutation, you first call `useMarkPaymentsNotCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPaymentsNotCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPaymentsNotCompletedMutation, { data, loading, error }] = useMarkPaymentsNotCompletedMutation({
 *   variables: {
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *   },
 * });
 */
export function useMarkPaymentsNotCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkPaymentsNotCompletedMutation, MarkPaymentsNotCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPaymentsNotCompletedMutation, MarkPaymentsNotCompletedMutationVariables>(MarkPaymentsNotCompletedDocument, options);
      }
export type MarkPaymentsNotCompletedMutationHookResult = ReturnType<typeof useMarkPaymentsNotCompletedMutation>;
export type MarkPaymentsNotCompletedMutationResult = Apollo.MutationResult<MarkPaymentsNotCompletedMutation>;
export type MarkPaymentsNotCompletedMutationOptions = Apollo.BaseMutationOptions<MarkPaymentsNotCompletedMutation, MarkPaymentsNotCompletedMutationVariables>;
export const ExportToPdfDocument = gql`
    mutation ExportToPDF($paymentId: String!) {
  exportToPDF(paymentId: $paymentId) {
    success
    stringData
  }
}
    `;
export type ExportToPdfMutationFn = Apollo.MutationFunction<ExportToPdfMutation, ExportToPdfMutationVariables>;

/**
 * __useExportToPdfMutation__
 *
 * To run a mutation, you first call `useExportToPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportToPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportToPdfMutation, { data, loading, error }] = useExportToPdfMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useExportToPdfMutation(baseOptions?: Apollo.MutationHookOptions<ExportToPdfMutation, ExportToPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportToPdfMutation, ExportToPdfMutationVariables>(ExportToPdfDocument, options);
      }
export type ExportToPdfMutationHookResult = ReturnType<typeof useExportToPdfMutation>;
export type ExportToPdfMutationResult = Apollo.MutationResult<ExportToPdfMutation>;
export type ExportToPdfMutationOptions = Apollo.BaseMutationOptions<ExportToPdfMutation, ExportToPdfMutationVariables>;
export const GetEncryptMyTokenDocument = gql`
    mutation getEncryptMyToken {
  EncryptMyToken {
    accessToken
    selectedFirmAccount
    headToURL
  }
}
    `;
export type GetEncryptMyTokenMutationFn = Apollo.MutationFunction<GetEncryptMyTokenMutation, GetEncryptMyTokenMutationVariables>;

/**
 * __useGetEncryptMyTokenMutation__
 *
 * To run a mutation, you first call `useGetEncryptMyTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetEncryptMyTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getEncryptMyTokenMutation, { data, loading, error }] = useGetEncryptMyTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetEncryptMyTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetEncryptMyTokenMutation, GetEncryptMyTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetEncryptMyTokenMutation, GetEncryptMyTokenMutationVariables>(GetEncryptMyTokenDocument, options);
      }
export type GetEncryptMyTokenMutationHookResult = ReturnType<typeof useGetEncryptMyTokenMutation>;
export type GetEncryptMyTokenMutationResult = Apollo.MutationResult<GetEncryptMyTokenMutation>;
export type GetEncryptMyTokenMutationOptions = Apollo.BaseMutationOptions<GetEncryptMyTokenMutation, GetEncryptMyTokenMutationVariables>;
export const UpdateUserInformationNotesDocument = gql`
    mutation UpdateUserInformationNotes($userInformationId: String!, $notes: String) {
  UpdateUserInformation(
    updateUserInformationInput: {id: $userInformationId, notes: $notes}
  ) {
    id
    notes
  }
}
    `;
export type UpdateUserInformationNotesMutationFn = Apollo.MutationFunction<UpdateUserInformationNotesMutation, UpdateUserInformationNotesMutationVariables>;

/**
 * __useUpdateUserInformationNotesMutation__
 *
 * To run a mutation, you first call `useUpdateUserInformationNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInformationNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInformationNotesMutation, { data, loading, error }] = useUpdateUserInformationNotesMutation({
 *   variables: {
 *      userInformationId: // value for 'userInformationId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateUserInformationNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserInformationNotesMutation, UpdateUserInformationNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserInformationNotesMutation, UpdateUserInformationNotesMutationVariables>(UpdateUserInformationNotesDocument, options);
      }
export type UpdateUserInformationNotesMutationHookResult = ReturnType<typeof useUpdateUserInformationNotesMutation>;
export type UpdateUserInformationNotesMutationResult = Apollo.MutationResult<UpdateUserInformationNotesMutation>;
export type UpdateUserInformationNotesMutationOptions = Apollo.BaseMutationOptions<UpdateUserInformationNotesMutation, UpdateUserInformationNotesMutationVariables>;
export const RemoveClient2FaDocument = gql`
    mutation RemoveClient2FA($userId: String!) {
  RemoveClient2FA(userId: $userId) {
    id
    has2Fa
  }
}
    `;
export type RemoveClient2FaMutationFn = Apollo.MutationFunction<RemoveClient2FaMutation, RemoveClient2FaMutationVariables>;

/**
 * __useRemoveClient2FaMutation__
 *
 * To run a mutation, you first call `useRemoveClient2FaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClient2FaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClient2FaMutation, { data, loading, error }] = useRemoveClient2FaMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveClient2FaMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClient2FaMutation, RemoveClient2FaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClient2FaMutation, RemoveClient2FaMutationVariables>(RemoveClient2FaDocument, options);
      }
export type RemoveClient2FaMutationHookResult = ReturnType<typeof useRemoveClient2FaMutation>;
export type RemoveClient2FaMutationResult = Apollo.MutationResult<RemoveClient2FaMutation>;
export type RemoveClient2FaMutationOptions = Apollo.BaseMutationOptions<RemoveClient2FaMutation, RemoveClient2FaMutationVariables>;
export const namedOperations = {
  Mutation: {
    UpdateClient: 'UpdateClient',
    LoginAs: 'LoginAs',
    ReturnToAccount: 'ReturnToAccount',
    ResendActivation: 'ResendActivation',
    AddTaxYearInterviewJob: 'AddTaxYearInterviewJob',
    GetPresignedURL: 'GetPresignedURL',
    UploadFileToUserOnDB: 'UploadFileToUserOnDB',
    DeleteClientFile: 'DeleteClientFile',
    DeleteClientRequestedFile: 'DeleteClientRequestedFile',
    UpdateClientFile: 'UpdateClientFile',
    UploadFileToFirmOnDB: 'UploadFileToFirmOnDB',
    DownloadFileFromS3: 'DownloadFileFromS3',
    DownloadAllFilesFromS3: 'DownloadAllFilesFromS3',
    MarkInterviewAsCompleted: 'MarkInterviewAsCompleted',
    MarkInterviewAsNotCompleted: 'MarkInterviewAsNotCompleted',
    CreateAnswer: 'CreateAnswer',
    UpdateAnswer: 'UpdateAnswer',
    SendInterview: 'SendInterview',
    MarkFilesReceived: 'MarkFilesReceived',
    MarkFilesNotReceived: 'MarkFilesNotReceived',
    MarkPaymentsCompleted: 'MarkPaymentsCompleted',
    MarkPaymentsNotCompleted: 'MarkPaymentsNotCompleted',
    ExportToPDF: 'ExportToPDF',
    getEncryptMyToken: 'getEncryptMyToken',
    UpdateUserInformationNotes: 'UpdateUserInformationNotes',
    RemoveClient2FA: 'RemoveClient2FA'
  },
  Fragment: {
    Answers: 'Answers',
    Tasks: 'Tasks'
  }
}